import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { TopBaseSlider } from '@/components/modules/pages/top/slider/TopBaseSlider';
/**
 * TOP: 選定事例のスライダー
 * @param props
 * @returns
 */
export const TopCaseSlider = (props) => {
    const { children, className = '' } = props;
    return _jsx(TopBaseSlider, Object.assign({ className: className }, { children: children }));
};
